// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import initialState from '../store/initialState';
import { clone } from './helper';
import { GenerateInviteDetail } from '../businessLogic/generateInviteDetails';
import { sortMeetingRooms, sortManageRoleNaming } from '../businessLogic/sorting';
import { removeDuplicateArray } from '../businessLogic/helperHooks';
import { combineReducers } from 'redux';
import {
  GET_MEETING_ROOMS,
  GOT_MEETING_ROOMS_IN_QV,
  CLEAR_MEETING_ROOM_IN_QV,
  UPDATE_MEETING_ROOM_SEARCH,
  UPDATE_MEETING_ROOM_FORM,
  RESET_MEETING_ROOM_FORM,
  CREATE_MEETING_ROOM,
  GOT_MEETING_ROOM_PARTICIPANTS,
  GET_MEETING_ROOM_PARTICIPANTS,
  CLICKED_JOIN_MEETING_ROOM,
  GET_MEETING_ROOM_DETAILS,
  GOT_MEETING_ROOM_DETAILS,
  UPDATE_FETCHING_MEETING_ROOM,
  ERROR_GETTING_MEETING_ROOM_DETAILS,
  GET_MEETING_ROOM_INVITE_DETAILS,
  GOT_MEETING_ROOM_INVITE_DETAILS,
  UPDATE_MEETING_ROOM,
  UPDATED_MEETING_ROOM,
  DELETE_MEETING_ROOM,
  DELETED_MEETING_ROOM,
  RESET_FETCHING_FLAG,
  CLICKED_NEW_MEETING_ROOM,
  CLICKED_UPDATE_MEETING_ROOM,
  SEND_SMS_INVITATION_MEETING_ROOM,
  SENT_SMS_INVITATION_MEETING_ROOM,
  GET_LAST_TIME_MEETING_ROOM_USED,
  GOT_LAST_TIME_MEETING_ROOM_USED,
  UPDATE_MEETING_ROOMS_PERMISSION,
  // Selected Participant
  UPDATE_SELECTED_PARTICIPANT_FORM_MR,
  // Select meeting room
  SELECTED_MEETING_ROOM,
  // Reset guest Link
  GUEST_LINK_UPDATED,
  RESET_EDIT_MEETING_ROOM_FORM,
  UPDATE_EDIT_MEETING_ROOM_FORM,
  //Manage users
  UPDATE_MEETING_ROOM_MEMBER_SEARCH,
  UPDATE_MR_SELECTED_USER_FOR_MANAGEMENT,
  GOT_AVAILABLE_ROLES_FOR_MEETING_ROOM,
  MR_ADD_USERS_FORM,
  UPDATE_ROLES_FOR_SELECTED_USER_IN_MR_MANAGE_USERS_PAGE,
  SELECT_MEETING_ROOM_ID,
  // Pagination
  GOT_MEETING_ROOMS_PAGINATION,
  RESET_MR_SEARCH_FROM,
  UPDATE_MR_SEARCH_FROM,
  UPDATE_CURRENT_ACTIVE_PAGENO_FOR_MRS_PAGE,
  IS_ON_MR_LISTING_PAGE,
} from '../actions/meetingRoom.js';
import { GOT_MEETING_ROOM_USERS } from '../actions/user.js';

const reducer = (state = initialState, action, cleanMeetingRoomForm = initialState.cleanMeetingRoomForm) => {
  switch (action.type) {
    case GET_MEETING_ROOMS:
      return objectAssign({}, state, { fetchingMeetingRooms: true });
    case GOT_MEETING_ROOMS_IN_QV:
      var sortedMeetingRooms = action.data.meetingRooms;
      return objectAssign({}, state, {
        fetchingMeetingRooms: false,
        meetingRoomsInQV: sortedMeetingRooms,
        userCurrentMeetingRoomCall: userCurrentMeetingRoomCall(sortedMeetingRooms),
        totalMeetingRooms: action.data.totalRows,
      });

    case CLEAR_MEETING_ROOM_IN_QV: {
      return objectAssign({}, state, {
        meetingRoomsInQV: initialState.meetingRoomsInQV,
      });
    }
    case UPDATE_MEETING_ROOMS_PERMISSION: {
      let meetingRooms = clone(state.meetingRooms);
      if (meetingRooms && meetingRooms.length > 0) {
        action.data.map((x) => {
          let meetingRoom = meetingRooms.find((mr) => mr.id == x.id);
          if (meetingRoom) {
            meetingRooms.permissions = x.permissions;
          }
        });
        meetingRooms = removeDuplicateArray(meetingRooms, 'id');
        return objectAssign({}, state, { meetingRooms: meetingRooms });
      } else {
        return state;
      }
    }

    case UPDATE_MEETING_ROOM_SEARCH:
      return objectAssign({}, state, { currentMeetingRoomNameFilter: action.data });
    case CREATE_MEETING_ROOM:
      var copy = clone(state);
      copy.meetingRoomForm.fetching = true;
      return objectAssign({}, state, { meetingRoomForm: copy.meetingRoomForm });
    case UPDATE_MEETING_ROOM_FORM:
      return objectAssign({}, state, { meetingRoomForm: action.data });
    case RESET_MEETING_ROOM_FORM:
      return objectAssign({}, state, { meetingRoomForm: cleanMeetingRoomForm });
    case GET_MEETING_ROOM_PARTICIPANTS:
      return objectAssign({}, state, { fetchingMeetingRoomParticipants: true });
    case GOT_MEETING_ROOM_PARTICIPANTS:
      var copy = clone(state);
      var toBeUpdated = copy.meetingRooms.find((x) => x.id == action.data.id);
      toBeUpdated.participants = action.data.participants;
      copy.fetchingMeetingRoomParticipants = false;
      return copy;
    case CLICKED_JOIN_MEETING_ROOM:
      return objectAssign({}, state, { joiningMeetingRoom: true });
    case GET_MEETING_ROOM_INVITE_DETAILS:
      return objectAssign({}, state, { fetchingInviteDetails: true });
    case GOT_MEETING_ROOM_INVITE_DETAILS:
      var copy = clone(state);
      var toBeUpdated = copy.meetingRooms.find((x) => x.id == action.data.meetingRoomId);
      if (toBeUpdated == undefined) {
        window.$log.warn('got meeting details for different meeting room', toBeUpdated);
      }
      toBeUpdated.invitationDetails = action.data;
      //Setting  Email body and subject
      let template = APP.LANGUAGE.Templates.Email,
        emailBody = GenerateInviteDetail.parseWithTemplate(toBeUpdated.invitationDetails, template.Body),
        description = template.Body;
      description = GenerateInviteDetail.parseWithTemplate(toBeUpdated.invitationDetails, description);
      description = description
        .split('')
        .splice(1, description.length - 2)
        .join(''); //removing quotes from end
      let subject = GenerateInviteDetail.parseWithTemplate(toBeUpdated.invitationDetails, template.Subject);
      //End setting Emailbody and subject
      toBeUpdated.invitationMessage = description;
      toBeUpdated.invitationSubject = subject;
      window.$log.warn('hardcoded meeting room details', toBeUpdated.invitationMessage);
      copy.meetingRoomForm = toBeUpdated;
      copy.fetchingInviteDetails = false;
      return copy;
    case GET_MEETING_ROOM_DETAILS:
      return objectAssign({}, state, { fetchingMeetingRoom: true });
    case GOT_MEETING_ROOM_DETAILS: {
      var copyMeetingRooms = clone(state.meetingRooms);
      let isOnMRListingPage = state.isOnMRListingPage;
      let meetingRoomNew = action.data;
      let meetingRoomFoundIndex = copyMeetingRooms.findIndex((x) => x.id == action.data.id);
      if (meetingRoomFoundIndex > -1) {
        if (!!action.data.isInSearchCriteria || !isOnMRListingPage) {
          // If it meets search term and exists in current set, replace the record
          let meetingroomURL = action.data.roomUrl;
          let meetingRoomNewDetail = {
            ...meetingRoomNew,
            roomUrl: meetingroomURL,
          };
          copyMeetingRooms[meetingRoomFoundIndex] = Object.assign(
            {},
            copyMeetingRooms[meetingRoomFoundIndex],
            meetingRoomNewDetail
          );
        } else {
          // If exists in current set but does not meet the search term, remove it
          copyMeetingRooms.splice(meetingRoomFoundIndex, 1);
        }
      } else {
        if (!!action.data.isInSearchCriteria || !isOnMRListingPage) {
          // If it meets the search criteria then add it
          copyMeetingRooms.push(meetingRoomNew);
        }
      }
      var sortedMeetingRooms = sortMeetingRooms(copyMeetingRooms);
      sortedMeetingRooms = removeDuplicateArray(sortedMeetingRooms, 'id');
      // If this updated meeting room and meeting room form is selected, then update the data for selected meeting room
      var selectedMeetingRoom = clone(state.selectedMeetingRoom);
      var selectedMeetingRoomNew = selectedMeetingRoom;
      if (selectedMeetingRoom.id == meetingRoomNew.id) {
        selectedMeetingRoomNew = objectAssign({}, selectedMeetingRoom, meetingRoomNew);
      }

      return objectAssign({}, state, {
        fetchingMeetingRoom: false,
        selectedMeetingRoom: selectedMeetingRoomNew,
        meetingRooms: sortedMeetingRooms,
        userCurrentMeetingRoomCall: userCurrentMeetingRoomCall(sortedMeetingRooms),
      });
    }
    case UPDATE_FETCHING_MEETING_ROOM:
      return objectAssign({}, state, {
        fetchingMeetingRoom: action.data,
      });

    case ERROR_GETTING_MEETING_ROOM_DETAILS:
      return objectAssign({}, state, {
        fetchingMeetingRoom: false,
      });
    case UPDATE_MEETING_ROOM:
      var copy = clone(state);
      copy.meetingRoomForm.fetching = true;
      return objectAssign({}, state, {
        meetingRoomForm: copy.meetingRoomForm,
        fetchingMeetingRoom: false,
      });
    case UPDATED_MEETING_ROOM:
      var copy = clone(state);
      var toBeUpdated = copy.meetingRooms.find((x) => x.id == action.data.id);
      toBeUpdated.guestCode = action.data.guestCode;
      toBeUpdated.name = action.data.name;
      copy.meetingRoomForm = action.data;
      copy.meetingRoomForm.fetching = false;
      return copy;

    case DELETE_MEETING_ROOM:
      var copy = clone(state.meetingRoomForm);
      copy.fetching = true;
      return objectAssign({}, state, { meetingRoomForm: copy });

    case DELETED_MEETING_ROOM: {
      let meetingrooms = state.meetingRooms.filter((p) => p.id !== action.data.id);
      meetingrooms = removeDuplicateArray(meetingrooms, 'id');

      let offset = state.meetingRooms.length - meetingrooms.length;
      let mrSearchForm = clone(state.mrSearchForm);
      let newMRSearchForm =
        offset > 0
          ? {
              ...mrSearchForm,
              totalRowsForSet: Math.max(mrSearchForm.totalRowsForSet - offset, 0) || 0,
              numberOfMRs: Math.max(mrSearchForm.numberOfMRs - offset, 0) || 0,
            }
          : mrSearchForm;
      return objectAssign({}, state, {
        meetingRooms: meetingrooms,
        fetching: false,
        mrSearchForm: newMRSearchForm,
      });
    }
    case RESET_FETCHING_FLAG:
      var copy = clone(state);
      copy.meetingRoomForm.fetching = false;
      return objectAssign({}, state, { meetingRoomForm: copy.meetingRoomForm });
    case CLICKED_NEW_MEETING_ROOM:
      var copy = clone(state);
      return objectAssign({}, state, { meetingRoomForm: copy.meetingRoomForm });
    case CLICKED_UPDATE_MEETING_ROOM:
      var copy = clone(state);
      copy.meetingRoomForm.clickedUpdateMeetingRoom = true;
      copy.meetingRoomForm.headerName = copy.meetingRoomForm.name;
      return objectAssign({}, state, { meetingRoomForm: copy.meetingRoomForm });
    case SEND_SMS_INVITATION_MEETING_ROOM:
      return objectAssign({}, state, { sendingSmsInvitation: true });
    case SENT_SMS_INVITATION_MEETING_ROOM:
      return objectAssign({}, state, { sendingSmsInvitation: false });
    case GET_LAST_TIME_MEETING_ROOM_USED:
      var copy = clone(state.meetingRoomForm);
      copy.fetching = true;
      return objectAssign({}, state, { meetingRoomForm: copy });

    case GOT_LAST_TIME_MEETING_ROOM_USED:
      var copy = clone(state.meetingRoomForm);
      copy.fetching = false;
      copy.lastTimeMeetingRoomUsed = action.data;
      return objectAssign({}, state, { meetingRoomForm: copy });

    // Select participant
    case UPDATE_SELECTED_PARTICIPANT_FORM_MR:
      return objectAssign({}, state, { selectedParticipantForm: action.data });
    // Select meeting room
    case SELECT_MEETING_ROOM_ID:
      return objectAssign({}, state, {
        selectedMeetingRoomId: action.data,
      });

    case SELECTED_MEETING_ROOM:
      return objectAssign({}, state, { selectedMeetingRoom: action.data });
    // Reset guest Link
    case GUEST_LINK_UPDATED:
      var copyState = clone(state);
      let meetingroomURL = action.data.roomUrl;
      let meetingroomGuestLinkLastUpdated = action.data.resetGuestCodeDateUTC;
      var copyMeetingRoomForm = copyState.meetingRoomForm;
      if (copyMeetingRoomForm.id === action.data.id) {
        var updatedMeetingRoomForm = {
          ...copyMeetingRoomForm,
          roomUrl: action.data.roomUrl,
          resetGuestCodeDateUTC: action.data.resetGuestCodeDateUTC,
        };
      }
      return objectAssign({}, state, { meetingRoomForm: updatedMeetingRoomForm });

    // Manage users
    case UPDATE_MEETING_ROOM_MEMBER_SEARCH:
      return objectAssign({}, state, { currentMeetingRoomMemberFilter: action.data });
    case UPDATE_MR_SELECTED_USER_FOR_MANAGEMENT:
      var manageUsersPage = {
        selectedUserId: action.data,
      };
      return Object.assign({}, state, {
        manageUsersPage: manageUsersPage,
      });
    case GOT_AVAILABLE_ROLES_FOR_MEETING_ROOM:
      var meetingRooms = clone(state.meetingRooms);
      if (action.data) {
        let availableRoles = sortManageRoleNaming(action.data.meetingRoomUsers);
        if (meetingRooms.length > 0)
          var mr = meetingRooms.find((selectedMR) => selectedMR.id == action.data.meetingRoomId);
        if (mr) {
          mr.availableRoles = availableRoles;
        }
      }
      meetingRooms = removeDuplicateArray(meetingRooms, 'id');
      return objectAssign({}, state, { meetingRooms: meetingRooms });

    case GOT_MEETING_ROOM_USERS: {
      if (state.selectedMeetingRoomId === action.data.meetingRoomId) {
        return objectAssign({}, state, {
          selectedMRUsersEmail: action.data.meetingRoomUsers.emailUsers,
        });
      } else {
        return state;
      }
    }

    case MR_ADD_USERS_FORM.SELECT_ROLE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, {
        selectedRoles: state.addUsersForm.selectedRoles.concat(action.data),
      });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case MR_ADD_USERS_FORM.UNSELECT_ROLE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, {
        selectedRoles: state.addUsersForm.selectedRoles.filter((item) => item != action.data),
      });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case MR_ADD_USERS_FORM.UPDATE_MESSAGE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, { message: action.data });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case MR_ADD_USERS_FORM.CLEAR_FORM: {
      // reset the form state
      return objectAssign({}, state, { addUsersForm: initialState.addUsersForm });
    }
    case MR_ADD_USERS_FORM.ADDING_USERS_TO_MEETING_ROOM: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm);
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }

    case UPDATE_ROLES_FOR_SELECTED_USER_IN_MR_MANAGE_USERS_PAGE:
      var manageUsersPage = clone(state.manageUsersPage);
      manageUsersPage.rolesForSelectedUser = action.data;
      return Object.assign({}, state, {
        manageUsersPage: manageUsersPage,
      });

    // MR pagination
    case GOT_MEETING_ROOMS_PAGINATION: {
      let currentMeetingRooms = clone(state.meetingRooms);
      let filteredMeetingRooms = action.data.pageNo == 1 ? [] : currentMeetingRooms;
      // When action.data.pageNo == 1, it means start a new search;
      // Has to reset currentActivePageNo to be 0 for new search; not reset to 1 because it will be incremented by another dispatch later
      let currentActivePageNo = action.data.pageNo == 1 ? 0 : state.mrSearchForm.currentActivePageNo;
      let meetingroomsNew = [...filteredMeetingRooms, ...action.data.meetingRooms];

      var sortedMeetingRooms = sortMeetingRooms(meetingroomsNew);
      sortedMeetingRooms = removeDuplicateArray(sortedMeetingRooms, 'id');

      let totalRows = parseInt(action.data.totalRows, 10);
      let filteredRows = parseInt(action.data.filteredRows, 10);

      let newMRSearchForm =
        // If fetch mrs list, then needs to update total number of mrs
        state.mrSearchForm.searchString == ''
          ? {
              ...state.mrSearchForm,
              totalRowsForSet: totalRows || 0,
              numberOfMRs: totalRows || 0,
              currentActivePageNo: currentActivePageNo,
            }
          : {
              ...state.mrSearchForm,
              totalRowsForSet: filteredRows,
              numberOfMRs: totalRows,
              currentActivePageNo: currentActivePageNo,
            };
      return objectAssign({}, state, {
        meetingRooms: sortedMeetingRooms,
        mrSearchForm: newMRSearchForm,
      });
    }
    case RESET_MR_SEARCH_FROM: {
      let mrSearchForm = clone(state.mrSearchForm);
      let currentNumberOfMRs = mrSearchForm.numberOfMRs || 0;
      // If current mr filter is not empty, use filter string as search string
      let searchString =
        typeof state.currentMeetingRoomNameFilter == 'string' && state.currentMeetingRoomNameFilter.trim() != ''
          ? state.currentMeetingRoomNameFilter
          : '';
      let resetMRSearchForm = {
        ...initialState.mrSearchForm,
        numberOfMRs: currentNumberOfMRs,
        searchString: searchString,
      };
      return objectAssign({}, state, {
        meetingRooms: initialState.meetingRooms,
        mrSearchForm: resetMRSearchForm,
      });
    }

    case UPDATE_MR_SEARCH_FROM: {
      let mrSearchForm = clone(state.mrSearchForm);
      let newMRSearchForm = {
        ...mrSearchForm,
        ...action.data,
      };
      return objectAssign({}, state, { mrSearchForm: newMRSearchForm });
    }

    case UPDATE_CURRENT_ACTIVE_PAGENO_FOR_MRS_PAGE: {
      let mrSearchForm = clone(state.mrSearchForm);
      let newMRSearchForm = {
        ...mrSearchForm,
        currentActivePageNo: parseInt(mrSearchForm.currentActivePageNo, 10) + parseInt(action.data, 10),
      };
      return Object.assign({}, state, {
        mrSearchForm: newMRSearchForm,
      });
    }
    case IS_ON_MR_LISTING_PAGE: {
      return Object.assign({}, state, {
        isOnMRListingPage: action.data,
      });
    }
    default:
      return state;
  }
};
let userCurrentMeetingRoomCall = (meetingRooms) => {
  //if the user is in a call at a meeting room, we return that meeting room object.
  //otherwise we return null
  if (meetingRooms) {
    return meetingRooms.find((x) => x.isUserInCall == true);
  }
  return null;
};
export default reducer;
